import {ProfiControlUser} from "@/model/ProfiControlUser";
import {
    CrudManager,
    deleteRequest,
    getRequest,
    patchRequest,
    postRequest
} from "@/scripts/ProfiControlRequests/CrudManager";
import {ProfiControlUserDto} from "@/model/ProfiControlUserDto";
import {CertificateDownload} from "@/scripts/Common/CertificateDownload";
import {ErrorResult} from "@/model/ErrorResult";
import {PAGINATION_COUNT} from "@/scripts/Constants/PaginationConstants";

export class ProfiControlUserRequester {
    
    public static Delete(url: string, token: string): void {
        CrudManager.Delete(url, token).catch((_) => {});
    }

    public static DownloadCertificate(url: string, token: string, user: ProfiControlUser): void {
        CrudManager.Get<string>(url, token)
            .then((response) => {
                const pfxByteArray = Uint8Array.from(
                    atob(response.data).split('').map(char => char.charCodeAt(0))
                );

                let filename = `${user.UserName}_certificate.pfx`;
                CertificateDownload.Create(pfxByteArray, filename);
            })
            .catch((_) => {
            });
    }

    public static RevokeCertificate(url: string, token: string, user: ProfiControlUser): void {
        CrudManager.Get(url, token)
            .then((response) => {
                if (response.status === 200) {
                    user.CertificateId = undefined;
                }
            })
            .catch((_) => {
                user.HasCertificateError = true;
            });
    }

    public static CreateCertificate(url: string, token: string, user: ProfiControlUser): void {
        CrudManager.Post<number>(url, user.GetModel(), token)
            .then((response) => {
                if (response.status === 200) {
                    user.Reset();
                    user.CertificateId = response.data;
                }
            })
            .catch((_) => {
                user.HasCertificateError = true;
            });
    }

    public static CreateDownloadLink(url: string, token: string, user: ProfiControlUser, baseLink: string): void {
        CrudManager.Get(url, token)
            .then((response) => {
                user.CertificateDownloadLink = baseLink + response.data;
            })
            .catch((_) => {
            });
    }
}

const deleteProficontrolUser = async (url: string, token: string): Promise<ErrorResult> => {
    let errorResult: ErrorResult = new ErrorResult();
    await deleteRequest(url, token)
        .catch((error) => {
            errorResult = error.response.data
            errorResult.hasError = true;
        });

    return errorResult
}

const createProficontrolUser = async (url: string, token: string, user: ProfiControlUser): Promise<[ProfiControlUserDto, ErrorResult]> => {
    let profiControlUserDto: ProfiControlUserDto = user.profiControlUserModel
    let errorResult: ErrorResult = new ErrorResult();
    
    await postRequest<ProfiControlUserDto>(url, user.GetModel(), token)
        .then((response) => {
            profiControlUserDto = response.data
        })
        .catch((error) => {
            errorResult = error.response.data
            errorResult.hasError = true
        });

    return [profiControlUserDto, errorResult];
}

const patchProficontrolUser = async (url: string, token: string, user: ProfiControlUser): Promise<[ProfiControlUserDto, ErrorResult]> => {
    let profiControlUserDto: ProfiControlUserDto = user.profiControlUserModel
    let errorResult: ErrorResult = new ErrorResult();
    
    await patchRequest<ProfiControlUserDto>(url, user.GetModel(), token)
        .then((response) => {
            profiControlUserDto = response.data
        })
        .catch((error) => {
            errorResult = error.response.data
            errorResult.hasError = true;
        });
    
    return [profiControlUserDto, errorResult];
}

const getProficontrolUsers = async (url: string, token: string): Promise<[number, ProfiControlUserDto[]]> => {
    let paginationCount: number = 0;
    let users: ProfiControlUserDto[] = []

    await getRequest<Array<ProfiControlUserDto>>(url, token)
        .then((response) => {
            users = response.data;
            paginationCount = Number.parseInt(response.headers[PAGINATION_COUNT])
        })
        .catch((_) => {});
    
    return [paginationCount, users];
} 



export {
    getProficontrolUsers,
    createProficontrolUser,
    patchProficontrolUser,
    deleteProficontrolUser
}
